import styles from './MeterView.module.scss';

interface MeterViewArgs {
    current: number;
    max?: number;
    isDice?: boolean;
}

const MeterView: React.FC<MeterViewArgs> = args => {
    const max = args.max ?? args.current;

    return <ul className={styles.meterView}>
        {new Array(max).fill(0).map((n, i) => {
            return <li className={`${i < args.current ? styles.filled : ""} ${args.isDice ? styles.dice : ""}`}></li>
        })}
    </ul>
}

export default MeterView;